import React from 'react';
// import PropTypes from 'prop-types';

import Loading from '../../loading';
import LoadingComp from './loading/LoadingComp';

const withLoading = (
  namespace,
  LoadingSpinner = Loading,
  isHiddenWhileLoading = true,
  loadingContainerStyles = {}, // Not currently used, must re-implement if you want to use this
) => (Comp) =>
  /* eslint-disable react/prop-types */
  class WithLoading extends React.PureComponent {
    render() {
      const isLoading = !namespace
        ? this.props.isDataLoading
        : this.props[namespace].isDataLoading;

      return (
        <LoadingComp
          isLoading={isLoading}
          LoadingSpinner={LoadingSpinner}
          isHiddenWhileLoading={isHiddenWhileLoading}
          loadingContainerStyles={loadingContainerStyles}
        >
          <Comp {...this.props} {...this.state} />
        </LoadingComp>
      );
    }
  };

export default withLoading;
